import React from 'react';
import { Colors } from '@components/Colors';
import {
  SelectWrapper,
  StyledArrowSvg,
  StyledDropdown,
  DropdownContainer,
  DropdownContainerItem,
  StyledLabel,
  StyledSpan,
  StyledText,
  SelecteStyledText,
  StyledFilterCircle,
  StyledPlaceholderCloudImage,
  StyledWrapper,
} from '@components/SelectFilter/SelectFilter.styles';
import { SelectFilterTag } from '@components/SelectFilterTag';

export type SelectFilterOptions = ReadonlyArray<{
  name: string;
  value: string;
  tag?: string;
  slug?: string;
  isChecked?: boolean;
}>;

export interface SelectProps<T> {
  className?: string;
  showIcon?: boolean;
  selectedOptions: string[];
  options: SelectFilterOptions;
  isOpen: boolean;
  selectType: string;
  selectLabel?: string;
  handleOpen: (e: React.MouseEvent) => void;
  onClickedOption: (selectedOptions: string[]) => void;
}

export const SelectFilter = <T extends string>({
  showIcon = false,
  selectedOptions,
  options,
  className,
  isOpen,
  selectType,
  selectLabel = 'Select',
  handleOpen,
  onClickedOption,
}: SelectProps<T>) => {
  const handleChange = (name: string, isChecked: boolean) => {
    if (isChecked) {
      selectedOptions = [...selectedOptions, name];
    } else {
      selectedOptions = selectedOptions.filter((item) => item !== name);
    }
    onClickedOption(selectedOptions);
  };
  return (
    <SelectWrapper className={className}>
      <StyledDropdown id={`selectDropdown${selectLabel}`} isOpen={isOpen} onClick={(e) => handleOpen(e)} skipRedirectWithTelemetry>
        <SelecteStyledText textAlign="center" variant="featureCopy17" color="neutra5" tagName="p">
          {selectLabel}
        </SelecteStyledText>
        {selectedOptions?.length > 0 ? (
          <StyledFilterCircle variant="featureHed17" tagName="p" color="neutra5" textAlign="center">
            {selectedOptions?.length}
          </StyledFilterCircle>
        ) : null}
        <StyledArrowSvg isOpen={isOpen} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.2525 8.80122C18.4868 9.03554 18.4868 9.41544 18.2525 9.64975L13.1312 14.7711C12.5063 15.3959 11.4933 15.3959 10.8684 14.7711L5.74898 9.65162C5.51466 9.41731 5.51466 9.03741 5.74898 8.80309C5.98329 8.56878 6.36319 8.56878 6.59751 8.80309L11.717 13.9225C11.8732 14.0788 12.1264 14.0788 12.2826 13.9225L17.404 8.80122C17.6383 8.56691 18.0182 8.56691 18.2525 8.80122Z"
            fill="#333333"
          />
        </StyledArrowSvg>
      </StyledDropdown>
      <DropdownContainer isOpen={isOpen}>
        {selectType === 'color' ? (
          <Colors
            options={options}
            selectedOptions={selectedOptions}
            onClickedColor={(selectedColors) => {
              onClickedOption(selectedColors);
            }}
          />
        ) : (
          <>
            {options.map((option, index) => (
              <DropdownContainerItem key={index}>
                <StyledLabel
                  className="container"
                  onClick={(event) => {
                    event.stopPropagation();
                  }}
                >
                  <input
                    type="checkbox"
                    checked={selectedOptions.some((item) => item === option.value)}
                    value={option.value}
                    onChange={(event) => {
                      event.stopPropagation();
                      handleChange(option.value, event.currentTarget.checked);
                    }}
                  />
                  <StyledSpan className="checkmark"></StyledSpan>
                  <StyledWrapper left={showIcon ? '32' : '0'}>
                    <StyledText textAlign="left" variant="caption" color="neutra6" tagName="p">
                      {option.name}
                    </StyledText>
                    {option.tag ? <SelectFilterTag value={option.tag} /> : null}
                  </StyledWrapper>
                  {showIcon ? (
                    <StyledPlaceholderCloudImage
                      src={option.value == 'aloha' ? 'wedding-website-gallery/single.svg' : 'wedding-website-gallery/multi.svg'}
                      alt=""
                      width="100%"
                      isMainSrcShown={true}
                      optimization="aggressive"
                    />
                  ) : null}
                </StyledLabel>
              </DropdownContainerItem>
            ))}
          </>
        )}
      </DropdownContainer>
    </SelectWrapper>
  );
};
